<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="jackpots-history-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{ afterResize: columnsWidthChanged }"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(shop_code)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(shop_name)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(jackpot)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(award_time)="data">{{
              $t(data.label)
            }}</template>
            <template v-slot:head(amount)="data">{{ $t(data.label) }}</template>

            <template v-slot:head(selected)>
              <label
                class="
                  kt-checkbox
                  kt-checkbox--single
                  kt-checkbox--all
                  kt-checkbox--solid
                "
              >
                <input
                  type="checkbox"
                  @click.stop
                  @change="selectAll"
                  v-model="checkAll"
                />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label
                class="
                  kt-checkbox
                  kt-checkbox--single
                  kt-checkbox--all
                  kt-checkbox--solid
                "
              >
                <input
                  type="checkbox"
                  @click.stop
                  :value="data.item.eid"
                  v-model="selected"
                />
                <span></span>
              </label>
            </template>

            <template v-slot:cell(shop_code)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>

            <template v-slot:cell(shop_name)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>

            <template v-slot:cell(jackpot)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/jackpots/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>

            <template v-slot:cell(username)="data">
              <span v-if="data.value">
                <span v-if="data.value.to">
                  <router-link :to="`/users/${data.value.to}`">{{
                    data.value.name
                  }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </span>
            </template>

            <template v-slot:cell(award_time)="data">
              <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
            </template>

            <template v-slot:cell(amount)="data">
              <span v-if="data.value">{{ round(data.value) }}</span>
              <span v-else>0.00</span>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space: nowrap" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                  >{{ $t("Apply") }}</b-button
                >
                <span class="pagination-sep" v-if="selected.length"></span>

                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{
                      (currentPage - 1) * perPage + 1
                    }}</span>
                    <span slot="end">{{ currentPage * perPage }}</span>
                    <span slot="total">{{ totalRows }}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="
                    $root.$emit('bv::refresh::table', 'jackpots-history-table')
                  "
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import BulkActionSelect from "@/components/BulkActionSelect";
import TableFilters from "@/components/TableFilters";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    BulkActionSelect,
    TableFilters,
  },
  name: "jackpots-history",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "jackpots-history",

      bulkAction: null,
      bulkActionOptions: [],

      filterOptions: [],

      isBusy: false,
      sortBy: "award_time",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
        {
          key: "shop_code",
          label: "Shop Code",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          ignore: true,
          class: "",
        },
        {
          key: "jackpot",
          label: "Jackpot",
          sortable: false,
          ignore: false,
          class: "",
        },
        {
          key: "award_time",
          label: "Award Time",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
          ignore: true,
          class: "",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "",
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "jackpots-history-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach((item) => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected,
      };

      this.$store
        .dispatch("jackpotHistory/bulkAction", bulkData)
        .finally(() => {
          loading.close();
          this.allSelected = false;
          this.selected = [];
          this.$root.$emit("bv::refresh::table", "jackpots-history-table");
        });
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const shopByID = this.$store.getters["cache/shopByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("jackpotHistory/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.eshop_id) {
                item.shop_code = {
                  to: item.eshop_id,
                  name: item.shop_code,
                };

                const shop = shopByID(item.eshop_id);
                if (shop) {
                  item.shop_name = {
                    to: item.eshop_id,
                    name: shop.name,
                  };
                } else {
                  item.shop_name = {
                    to: item.eshop_id,
                    name: item.eshop_id,
                  };
                }
              }

              if (item.euser_id) {
                item.username = {
                  to: item.euser_id,
                  name: item.username,
                };
              }

              if (item.ejackpot_id) {
                item.jackpot = {
                  to: item.ejackpot_id,
                  name: item.jackpot_name,
                };
              }
            });
            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    redirect() {},
  },
};
</script>

<style lang="scss" scoped>
</style>

